import { render, staticRenderFns } from "./newsItem.vue?vue&type=template&id=994db8b6"
import script from "./newsItem.vue?vue&type=script&lang=js"
export * from "./newsItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports